import { IconArrow } from "@icons/index";
import { Trans } from "react-i18next";
import "./index.scss";
import { useNavigate } from "react-router-dom";
import classNames from "classnames";

export const PageHeader = ({
  title,
  className,
  allowClickThrough,
  showBack = true,
  disabledBack = false,
  onBack,
}: {
  title?: React.ReactNode;
  className?: string;
  allowClickThrough?: boolean;
  showBack?: boolean;
  disabledBack?: boolean;
  onBack?: () => void;
}) => {
  const navigate = useNavigate();

  return (
    <div
      className={classNames(
        "page_header h-[53px] px-[16px] w-full relative flex items-center gap-[10px] z-10 border-b border-kds-border",
        allowClickThrough && "pointer-events-none",
        className,
      )}
    >
      {showBack && (
        <div
          className={classNames(
            "back-home rounded-[8px]!",
            allowClickThrough && "pointer-events-auto",
            disabledBack && "opacity-40 cursor-not-allowed pointer-events-none",
          )}
          onClick={() => {
            if (disabledBack) return;
            if (onBack) {
              onBack();
            } else {
              const authPaths = ["/authorization", "/login", "/signup", "/add-password", "/reset-password"];
              const onPopState = () => {
                if (authPaths.some((p) => window.location.pathname.startsWith(p))) {
                  navigate("/video", { replace: true });
                }
              };
              window.addEventListener("popstate", onPopState, { once: true });
              navigate(-1);
            }
          }}
        >
          <IconArrow className="w-[24px] h-[24px] shrink-0" />
        </div>
      )}
      {title && (
        <span className="text-kds-fg font-bold text-[16px]">
          <Trans>{title}</Trans>
        </span>
      )}
    </div>
  );
};
